import './scss/main.scss'
import lazySizes from 'lazysizes'
import { shouldInit } from './components'
import setViewHeight from '@/utils/setViewHeight'

setViewHeight()

lazySizes.cfg.expand = 1
lazySizes.cfg.expFactor = 1
lazySizes.cfg.throttleDelay = 200

if (shouldInit.length) {
  shouldInit.forEach(component => component.init())
}
